"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CM_FSAGetOrderRequest = exports.CM_FSArbitragingAppProcessor = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const FutureUtils_1 = require("../../CommonUtils/FutureUtils/FutureUtils");
const TextAndSliderSyncTool_1 = require("../../CommonUtils/TextAndSliderSyncTool");
const FSArbitragingProcessor_1 = require("../FSArbitraging/FSArbitragingProcessor");
const FSATools_1 = require("../FSATools");
const CM_FSArbitragingTools_1 = require("./CM_FSArbitragingTools");
const CM_FSArbitragingAppProcessor = (baseCoin, quoteCoin, invest, investPercent, investActionType, priceDiffPercent, orderType, spotSymbolMap, balance, tradeAPI) => {
    var _a;
    const spotSymbol = (0, react_1.useMemo)(() => {
        if (!baseCoin || !quoteCoin) {
            return;
        }
        return spotSymbolMap.get(`${baseCoin.spotCoin}/${quoteCoin.spotCoin}`);
    }, []);
    const priceDiffLimit = (0, react_1.useMemo)(() => {
        return new trade_utils_lib_1.SafeDecimal(priceDiffPercent).mul(0.01).toString();
    }, [priceDiffPercent]);
    const priceOffsetRate = FSArbitragingProcessor_1.FSArbitragingProcessor.useFSAPriceGap(TradeAPILib_1.ExchangeID.PIONEXV2, baseCoin === null || baseCoin === void 0 ? void 0 : baseCoin.spotCoin, quoteCoin === null || quoteCoin === void 0 ? void 0 : quoteCoin.spotCoin, TradeAPILib_1.ExchangeID.PIONEX_SWAP, baseCoin === null || baseCoin === void 0 ? void 0 : baseCoin.swapCoin, quoteCoin === null || quoteCoin === void 0 ? void 0 : quoteCoin.swapCoin);
    const fundingFeeRateHistories = (0, FSATools_1.useArbitrageFundingFeeRateHistories)(orderType, baseCoin ? `${baseCoin.spotCoin}/USD` : undefined, undefined, true);
    const fundingFeeRateHistory = fundingFeeRateHistories.length && baseCoin ? fundingFeeRateHistories[0] : undefined;
    const fundingCountDown = (0, FutureUtils_1.useFundingRateCountDown)(fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.next_funding_fee_time);
    const fundingRateStr = (0, react_1.useMemo)(() => {
        const rate = fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate;
        const rateStr = rate ? trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(rate).mul(100), false, true, 4) : "--";
        return `${rateStr} / ${fundingCountDown}`;
    }, [fundingCountDown, fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate]);
    const precision = (_a = spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.precision) !== null && _a !== void 0 ? _a : 2;
    const minInvest = (0, react_1.useMemo)(() => {
        return baseCoin ? `${(0, CM_FSArbitragingTools_1.CM_FSAMinInvest)(baseCoin)}` : "";
    }, [baseCoin]);
    const maxInvest = (0, react_1.useMemo)(() => {
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(balance, precision);
    }, [balance, precision]);
    const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, invest, investPercent, balance, precision);
    const investState = (0, react_1.useMemo)(() => {
        const state = {
            state: "normal",
            min: minInvest,
            max: maxInvest,
        };
        if (parseInvest && minInvest && quoteCoin) {
            if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                state.state = "small";
            }
            if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(maxInvest))) {
                state.state = "large";
            }
        }
        return state;
    }, [minInvest, maxInvest, parseInvest, quoteCoin]);
    return {
        invest: parseInvest,
        investPercent: parseInvestPercent,
        investState,
        balance,
        baseCoin,
        quoteCoin,
        precision,
        orderType,
        minInvest,
        maxInvest,
        priceOffsetRate,
        fundingFeeRateHistory,
        tradeAPI,
        priceDiffLimit,
        fundingRate: fundingRateStr,
    };
};
exports.CM_FSArbitragingAppProcessor = CM_FSArbitragingAppProcessor;
const CM_FSAGetOrderRequest = (params, $st) => {
    if (!params.invest) {
        const param = $st("trading_total_investment");
        throw $st("trade_input_param_please", { param });
    }
    if (!params.baseCoin) {
        throw $st("cm_fsa_choose_coin_please");
    }
    if (!params.quoteCoin) {
        throw $st("cm_fsa_choose_invest_coin_please");
    }
    if (params.investState.state === "small") {
        throw $st("trade_error_low_amount", {
            amount: `${params.minInvest} ${params.quoteCoin.displayName}`,
        });
    }
    else if (params.investState.state === "large") {
        if (new trade_utils_lib_1.SafeDecimal(params.invest).greaterThan(new trade_utils_lib_1.SafeDecimal(params.balance))) {
            throw $st("trade_error_balance_not_enough");
        }
        throw $st("trade_error_high_cost", {
            cost: `${params.investState.max} ${params.quoteCoin.displayName}`,
        });
    }
    if (new trade_utils_lib_1.SafeDecimal(params.priceDiffLimit).lessThan(-0.5)) {
        throw $st("fsa_create_order_price_diff_too_low", { min: "-50%" });
    }
    return {
        type: params.orderType,
        base: params.baseCoin.spotCoin,
        quote: params.quoteCoin.spotCoin,
        swap_base: params.baseCoin.swapCoin,
        swap_quote: params.quoteCoin.swapCoin,
        swap_exchange: TradeAPILib_1.ExchangeID.PIONEX_SWAP,
        investment: params.invest,
        open_price_diff_limit: params.priceDiffLimit,
    };
};
exports.CM_FSAGetOrderRequest = CM_FSAGetOrderRequest;
